import { Link } from "react-router-dom";
import { filmCategoryMeta, newsCategoryMeta } from "@/mocks/categories";
import type { FilmCategory, NewsCategory } from "@/types";

const filmTypes: FilmCategory[] = ["movie", "tv", "variety"];
const newsTypes: NewsCategory[] = ["industry", "company", "release", "interview"];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-youtube-line", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">星光传媒</span>
                <span className="mt-0.5 text-[10px] tracking-[0.2em] text-background-400">
                  STARLIGHT MEDIA
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              专注影视内容制作与传播，涵盖电影、电视剧、综艺等多元类型，让每一个好故事都被看见。
            </p>
            <div className="mt-5 flex gap-2">
              {socials.map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  aria-label={item.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-50/10 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${item.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">影视分类</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {filmTypes.map((type) => (
                <li key={type}>
                  <Link
                    to={`/category/${type}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {filmCategoryMeta[type].label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/favorites"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  我的收藏
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">资讯分类</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {newsTypes.map((type) => (
                <li key={type}>
                  <Link
                    to={`/news/${type}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {newsCategoryMeta[type].label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">关于星光</h4>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/news/company"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  公司新闻
                </Link>
              </li>
              <li>
                <Link
                  to="/news/industry"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  行业动态
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <div className="flex flex-col gap-4 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 星光传媒 STARLIGHT MEDIA. 保留所有权利。</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <span>友情链接：</span>
              <span className="text-background-300">中国电影家协会</span>
              <span className="text-background-300">影视产业观察</span>
              <span className="text-background-300">青年创作者联盟</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}